const findAddressObjByType = (
  type: string,
  size: string,
  value: google.maps.places.PlaceResult
) => {
  const addressData = value.address_components?.find((address) => address.types.includes(type));
  if (!addressData) return '';
  return addressData[size === 'long' ? 'long_name' : 'short_name'];
};

export const fetchSuburbSuggestionsFromGoogle = async (
  query: string,
  stateToSearch?: string
): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const autocompleteService = new window.google.maps.places.AutocompleteService();
    const autocompleteRef = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );

    autocompleteService.getPlacePredictions(
      {
        input: stateToSearch ? `${query}, ${stateToSearch}` : query,
        componentRestrictions: { country: 'au' },
      },
      (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          const results =
            predictions?.map((prediction) => ({
              placeId: prediction.place_id,
            })) ?? [];

          // Fetching details for each prediction
          const promises = results.map(async (prediction) => {
            const placeDetails = await new Promise<any>((resolveDetails, rejectDetails) => {
              autocompleteRef.getDetails({ placeId: prediction.placeId }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && place) {
                  const suburb = findAddressObjByType('locality', 'long', place);
                  const state = findAddressObjByType('administrative_area_level_1', 'short', place);
                  const postcode = findAddressObjByType('postal_code', 'short', place);
                  resolveDetails({
                    stateOrRegion: state,
                    locality: suburb,
                    suburbOrTown: suburb,
                    postCode: postcode,
                  });
                } else {
                  rejectDetails(new Error('Error fetching place details'));
                }
              });
            });
            return placeDetails;
          });

          // Wait for all details to be fetched
          Promise.all(promises)
            .then((allPlaceDetails) => resolve(allPlaceDetails))
            .catch((error) => {
              reject(new Error('Error fetching suburb details: ' + error.message));
            });
        } else {
          reject(new Error('Error fetching suburb predictions'));
        }
      }
    );
  });
};
